import { render, staticRenderFns } from "./EditableLookupCell.vue?vue&type=template&id=2856b86c&scoped=true&"
import script from "./EditableLookupCell.vue?vue&type=script&lang=js&"
export * from "./EditableLookupCell.vue?vue&type=script&lang=js&"
import style0 from "./EditableLookupCell.vue?vue&type=style&index=0&id=2856b86c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2856b86c",
  null
  
)

export default component.exports